import { Navigate, useLocation, useParams, type RouteObject } from "react-router";

/** The builder loads on first visit, so the portal's own pages stay light. */
const pages = () => import("./pages.js");

/** The builder's old addresses now open the Plan page (DESIGN §17.6). */
function ToPlan() {
  const { monday } = useParams();
  const { search } = useLocation();
  return <Navigate to={(monday ? `/w/${monday}/plan` : "/") + search} replace />;
}

export const planRoute = {
  lazy: async () => {
    const { PlanPage } = await pages();
    return { Component: PlanPage };
  },
};

export const builderRoutes: RouteObject[] = [
  { path: "/builder", element: <ToPlan /> },
  { path: "/builder/:monday", element: <ToPlan /> },
  {
    path: "/groups",
    lazy: async () => {
      const { GroupsRoute } = await pages();
      return { Component: GroupsRoute };
    },
  },
  {
    path: "/team",
    lazy: async () => {
      const { Guard, TeamPage } = await pages();
      return {
        Component: () => (
          <Guard need="admin">
            <TeamPage />
          </Guard>
        ),
      };
    },
  },
];
